import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, text, align = "left", dark = false }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      <Reveal>
        <p className={`text-xs font-semibold uppercase tracking-[0.2em] ${dark ? "text-techblue" : "text-techblue"}`}>
          {eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className={`mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight ${dark ? "text-white" : "text-graphite"}`}>
          {title}
        </h2>
      </Reveal>
      {text && (
        <Reveal delay={0.14}>
          <p className={`mt-4 text-base lg:text-lg leading-relaxed ${dark ? "text-white/70" : "text-steel"}`}>
            {text}
          </p>
        </Reveal>
      )}
    </div>
  );
}
